let Flags = {
    "Australia": "🇦🇺",
    "Argentina": "🇦🇷",
    "Belgium": "🇧🇪",
    "Brazil": "🇧🇷",
    "Canada": "🇨🇦",
    "Switzerland": "🇨🇭",
    "Germany": "🇩🇪",
    "France": "🇫🇷",
    "United Kingdom": "🇬🇧",
    "Mexico": "🇲🇽",
    "Netherlands": "🇳🇱",
    "Sweden": "🇸🇪",
    "United States": "🇺🇸",
    "Iceland": "🇮🇸",
    "Japan": "🇯🇵",
    "Portugal": "🇵🇹",
    "Italy": "🇮🇹",
    "Spain": "🇪🇸",
    "Czech Republic": "🇨🇿",
    "Greece": "🇬🇷",
    "Hong Kong": "🇭🇰",
    "Hungary": "🇭🇺",
    "Israel": "🇮🇱",
    "India": "🇮🇳",
    "South Korea": "🇰🇷",
    "Lithuania": "🇱🇹",
    "Poland": "🇵🇱",
    "Romania": "🇷🇴",
    "Russia": "🇷🇺",
    "Singapore": "🇸🇬",
    "Slovakia": "🇸🇰",
    "Thailand": "🇹🇭",
    "Turkey": "🇹🇷",
    "South Africa": "🇿🇦"
}

export default Flags